import { useEffect, useRef, useState } from 'react'
import { DateTime } from 'luxon'

// check if the event state has changed to started
// or if the event end date has passed
// show & hide vote now button accordingly
// returns boolean of event open
export const useCheckVotingOpenStateChange = ({ event, fetchEvent, closeDate }: any) => {
  const [loadingEvent, setLoadingEvent] = useState(false)
  const [votingOpen, setVotingOpen] = useState(false)
  const [loadingVotingOpen, setLoadingVotingOpen] = useState(true)
  const eventRef = useRef(event)
  eventRef.current = event

  // check if event state has changed to started at scheduled event open time
  const checkVoteStarted = async () => {
    if (!fetchEvent) {
      return
    }
    if (eventRef.current.state === 'finalized') {
      const dateTime = DateTime.fromISO(eventRef.current.openDate)
      const diff = dateTime.diffNow('seconds').get('seconds')
      // fetch event from api to see if switched to started
      // try for up to 60 seconds after event open time, switches around 30
      if (!votingOpen && diff < 0 && diff >= -60 && !loadingEvent) {
        setLoadingEvent(true)
        await fetchEvent()
        setLoadingEvent(false)
      }
    }
  }

  const checkEventState = () => {
    const dateTime = DateTime.fromISO(closeDate)
    const totalSecsLeftInEvent = dateTime.diffNow('seconds').get('seconds')
    // event has ended, voting is now closed,
    // event state may not be updated yet, but vote now button should be hidden
    if (totalSecsLeftInEvent < 0 && votingOpen) {
      setVotingOpen(false)
      // the vote now button is not visible and the event has started and their is time left in the event
      // show the vote now button, set voting to open
    } else if (eventRef.current.state === 'started' && !votingOpen && totalSecsLeftInEvent > 0) {
      setVotingOpen(true)
      // if the event state is not started, set voting to not open, hide vote now button
    } else if (eventRef.current.state !== 'started' && votingOpen) {
      setVotingOpen(false)
    }
    setLoadingVotingOpen(false)
    checkVoteStarted()
  }

  useEffect(() => {
    const interval = setInterval(checkEventState, 1000)
    return () => clearInterval(interval)
  }, [votingOpen])

  return { votingOpen, loadingVotingOpen }
}
